import { useInfiniteQuery } from '@tanstack/react-query';
import servicePeople from 'services/people';

const PER_PAGE = 20;

/**
 * Infinite query hook to fetch audit trail entries for a person.
 * Loads pages incrementally via "Load More".
 *
 * @param {number|string} personId - The person ID to fetch audit trail for
 * @param {Object} [filters] - Optional filters
 * @param {string} [filters.dateFrom] - Start date (YYYY-MM-DD)
 * @param {string} [filters.dateTo] - End date (YYYY-MM-DD)
 * @param {number} [filters.personDataKeyId] - Person data key ID to filter by field
 * @param {Object} [options] - Additional useInfiniteQuery options
 * @returns {Object} useInfiniteQuery result object
 */
export function useAuditTrailInfiniteQuery(personId, { dateFrom, dateTo, personDataKeyId } = {}, options = {}) {
    return useInfiniteQuery({
        queryKey: ['audit-trail', personId, dateFrom, dateTo, personDataKeyId],
        queryFn: ({ pageParam = 1 }) =>
            servicePeople.getAuditTrail(personId, {
                page: pageParam,
                perPage: PER_PAGE,
                dateFrom,
                dateTo,
                personDataKeyId
            }),
        getNextPageParam: lastPage => {
            const { from, to, per_page } = lastPage;
            const currentPage = lastPage.current_page;
            if (to - from + 1 >= Number(per_page)) {
                return currentPage + 1;
            }
            return undefined;
        },
        enabled: !!personId,
        ...options
    });
}
